import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { publicApi, imgUrl } from "../lib/api";
import { fmtDate } from "../lib/format";
import { CategoryBadge } from "../components/site/CategoryBadge";

export default function AnnouncementDetailPage() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);
  const nav = useNavigate();
  const goBack = () => (window.history.length > 1 ? nav(-1) : nav("/"));

  useEffect(() => {
    setA(null);
    setErr(false);
    publicApi.get(`/public/announcements/${id}`).then((r) => setA(r.data)).catch(() => setErr(true));
  }, [id]);

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <button onClick={goBack} data-testid="announcement-back-btn"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1B4332] text-white text-sm font-bold hover:bg-[#143326] transition-colors">
        <ArrowLeft size={16} /> Geri
      </button>
      {err && <p className="mt-10 text-slate-500" data-testid="announcement-not-found">Duyuru bulunamadı.</p>}
      {!a && !err && <p className="mt-10 text-slate-500">Yükleniyor...</p>}
      {a && (
        <div className="fade-up">
          <div className="flex items-center gap-3 mt-8"><CategoryBadge category={a.category} /><span className="text-sm text-slate-400">{fmtDate(a.date)}</span></div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1B4332] mt-4 leading-tight" data-testid="announcement-detail-title">{a.title}</h1>
          {a.image_path && <img src={imgUrl(a.image_path)} alt={a.title} className="mt-8 w-full max-h-[480px] object-cover rounded-[2rem]" data-testid="announcement-detail-image" />}
          <div className="mt-8 text-base sm:text-lg leading-relaxed text-slate-700 whitespace-pre-line" data-testid="announcement-detail-content">{a.content}</div>
          <button onClick={goBack} data-testid="announcement-back-bottom-btn"
            className="mt-12 inline-flex items-center gap-2 px-6 py-3 rounded-full border border-black/10 bg-white text-slate-700 font-bold hover:bg-[#D8F3DC] transition-colors">
            <ArrowLeft size={18} /> Geri dön
          </button>
        </div>
      )}
    </article>
  );
}
